import { Injectable, model } from '@angular/core'
import { lastValueFrom } from 'rxjs'
import { BizTaskApiService } from '@interserve-corp/angular'
import { CompanyInfo } from '../services/company.service'

@Injectable({
  providedIn: 'root',
})
export class ApiCatalogService {
  constructor(private bizTaskApiService: BizTaskApiService) {}
  //  APIカタログ：bizMarcheMacro
  //  API:customer/createAccount','post', req:'{model}
  //  説明：アカウントを新規登録する
  async CreateAccountWithCustomer(payload: AccountwithCustomer): Promise<any> {
    const apiProfileId = 'f3d97385-e77a-4844-9923-69c5d8708c6b'
    const body = {
      model: payload,
    }
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }

  //  APIカタログ：bizMarcheMacro
  //  API:accounts/checkDuplicate?nickName={nickName}
  //  説明：ニックネームの重複チェック
  async NicknameSearch(nickname: string): Promise<any> {
    const apiProfileId = '3a94e1d2-d782-4839-b6e8-5212d61e1579'
    const body = { nickName: nickname }
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }

  // APIカタログ：bizMarcheMacro
  // API：termsOfAccountCreation
  // 説明：アカウント登録時の利用規約の取得
  async getTermOfService() {
    const body = {}
    const apiProfileId = '817ef17c-0904-47db-9585-f12c1e6c02d2'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }
  // APIカタログ：bizMarcheMacro
  // API：roles/{companyId}/administrators
  // 説明：管理者カタログへの追加（会社Idと顧客Idを紐づけ）
  async postAdminRole(companyId: string, customerId: string) {
    const body = {
      companyId: companyId,
      model: { id: customerId },
    }
    const apiProfileId = '2b29bc24-a2ff-48a9-a69a-28d6c183a9c1'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }

  // APIカタログ：bizMarcheMacro
  // API：contractTypes/{contractTypeId}/accounts/{accountId}','post', req:'{model}
  // 説明：利用規約の証跡を保存する
  async postConfirmToS(contractTypeId: string, accountId: string, model: any) {
    const body = {
      contractTypeId: contractTypeId,
      accountId: accountId,
      model: model,
    }
    const apiProfileId = 'dd0be1aa-1e78-4129-8bed-6fea3904fce0'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }
  // APIカタログ：MyideaMacroApi
  // API： organizationCompany/likeSearchAllCorporate
  // 説明：法人検索
  async postSearchAllCorporate(corporateNumber: number) {
    const body = {
      model: { corporateNumber: corporateNumber },
    }
    // const apiProfileId = 'cd3cb9a1-bbc4-42d9-92db-4d063a53e77b'
    const apiProfileId = '314cd36e-5935-4bbc-b09f-ffd501193efc'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }
  // APIカタログ：backend-organization-chart-api
  // API： fieldPatterns
  // 説明：会社登録項目パターンをすべてを取得する
  async getCompanyFieldPattern() {
    const body = {}
    const apiProfileId = '7d617475-41e1-47f5-b408-ffe7b3916129'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }

  // APIカタログ：backend-organization-chart-api
  // API： company/customers/{customerId}
  // 説明：会社データを登録し、その会社と作成者を紐づける
  async postCompanyAndCustomer(customerId: string, payload: any) {
    const body = {
      customerId: customerId,
      model: payload,
    }
    const apiProfileId = '45b30ab4-fc42-42ec-814d-aed457949106'
    const ret = await this.sendExecuteTask(body, apiProfileId)
    return ret.data
  }

  //API実行
  private async sendExecuteTask(body: any, apiProfiledId: string): Promise<any> {
    return await lastValueFrom(this.bizTaskApiService.executeTask(body, apiProfiledId))
  }
}

export interface AccountwithCustomer {
  accountId?: string
  customerId?: string
  customerCd?: string
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
  // かな入力から変換したローマ字表記（登録画面で自動生成する）
  familyNameHepburn?: string
  firstNameHepburn?: string
  mailAddress: string
  nickname: string
  password: string
}
